module.exports = __webpack_public_path__ + "img/taski-logo.ae12b689.png";